import {AccountLinkingRedirector} from './account-linking-redirector';

export default AccountLinkingRedirector;
